module.exports = __webpack_public_path__ + "img/giftbox-black@2x.15c766f.png";